export function Spinner({ label = 'Loading' }: { label?: string }) {
  return <span className="ne-spinner" role="status" aria-label={label} />;
}
